import { Link } from 'react-router-dom';
import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';
import SEO from '../../components/common/SEO';

export default function ThingsToDo() {
  const activities = [
    {
      title: 'Hike Acatenango Volcano',
      category: 'Adventure',
      difficulty: 'Challenging',
      time: '2 days',
      cost: '$$$',
      icon: 'ri-flashlight-line',
      link: '/acatenango-hike-from-antigua'
    },
    {
      title: 'Explore Santa Catalina Arch',
      category: 'Cultural',
      difficulty: 'Easy',
      time: '30 mins',
      cost: 'Free',
      icon: 'ri-building-line',
      link: '/antigua-guatemala-travel-guide'
    },
    {
      title: 'Visit Cerro de la Cruz',
      category: 'Viewpoint',
      difficulty: 'Easy',
      time: '1 hour',
      cost: 'Free',
      icon: 'ri-landscape-line',
      link: '/antigua-guatemala-travel-guide'
    },
    {
      title: 'Tour a Coffee Farm',
      category: 'Experience',
      difficulty: 'Easy',
      time: '3-4 hours',
      cost: '$$',
      icon: 'ri-cup-line',
      link: '/day-trips-from-antigua-guatemala'
    },
    {
      title: 'Pacaya Volcano Day Trip',
      category: 'Adventure',
      difficulty: 'Moderate',
      time: '6 hours',
      cost: '$$',
      icon: 'ri-fire-line',
      link: '/day-trips-from-antigua-guatemala'
    },
    {
      title: 'Explore Colonial Churches',
      category: 'Cultural',
      difficulty: 'Easy',
      time: '2-3 hours',
      cost: '$',
      icon: 'ri-ancient-gate-line',
      link: '/antigua-guatemala-travel-guide'
    },
    {
      title: 'Chichicastenango Market',
      category: 'Cultural',
      difficulty: 'Easy',
      time: 'Full day',
      cost: '$$',
      icon: 'ri-shopping-bag-line',
      link: '/day-trips-from-antigua-guatemala'
    },
    {
      title: 'Relax in Boutique Hotels',
      category: 'Relaxation',
      difficulty: 'Easy',
      time: 'Flexible',
      cost: '$$$',
      icon: 'ri-hotel-bed-line',
      link: '/best-hotels-in-antigua-guatemala'
    },
    {
      title: 'Take a Spanish Class',
      category: 'Learning',
      difficulty: 'Easy',
      time: '1-4 weeks',
      cost: '$$',
      icon: 'ri-book-open-line',
      link: '/antigua-guatemala-travel-guide'
    },
    {
      title: 'Visit Hobbitenango',
      category: 'Experience',
      difficulty: 'Easy',
      time: '4-5 hours',
      cost: '$$',
      icon: 'ri-home-smile-line',
      link: '/day-trips-from-antigua-guatemala'
    }
  ];

  const faqs = [
    {
      question: 'What is Antigua Guatemala best known for?',
      answer: 'Antigua Guatemala is best known for its perfectly preserved Spanish colonial architecture, colorful baroque churches, cobblestone streets, and dramatic setting surrounded by three volcanoes. It\'s a UNESCO World Heritage site and one of Central America\'s most beautiful cities. The city is also famous for world-class coffee production, the challenging Acatenango volcano hike with views of erupting Fuego, and vibrant cultural experiences including traditional markets and Spanish language schools.'
    },
    {
      question: 'Is Antigua Guatemala worth visiting?',
      answer: 'Absolutely. Antigua Guatemala is one of the most worthwhile destinations in Central America for US travelers. The city offers a unique combination of colonial charm, adventure activities like volcano hiking, rich coffee culture, and authentic cultural experiences—all within 45 minutes of Guatemala City airport. Whether you have 2 days or a week, Antigua provides excellent value, safety compared to other parts of Guatemala, and unforgettable experiences that rival destinations in Europe or South America.'
    },
    {
      question: 'What should I not miss in Antigua Guatemala?',
      answer: 'Don\'t miss hiking Acatenango volcano for sunrise views of erupting Fuego (the most iconic experience), exploring the colonial center around Santa Catalina Arch, visiting Cerro de la Cruz for panoramic city views, touring a coffee plantation, and experiencing the sunset from a rooftop restaurant. If you have time, add a day trip to Chichicastenango market or Lake Atitlán. These experiences capture the essence of what makes Antigua special.'
    },
    {
      question: 'How walkable is Antigua Guatemala?',
      answer: 'Antigua is extremely walkable. The colonial center is compact—about 1 square mile—and most major attractions, restaurants, hotels, and shops are within a 10-15 minute walk of Central Park. The cobblestone streets add charm but wear comfortable shoes. For attractions outside the center like Cerro de la Cruz or coffee farms, you can take an inexpensive tuk-tuk or taxi. Walking is the best way to discover hidden courtyards, local markets, and authentic street life.'
    },
    {
      question: 'Are volcano hikes in Antigua safe?',
      answer: 'Yes, volcano hikes from Antigua are generally safe when done with reputable tour operators. Acatenango and Pacaya are the two main options. Acatenango is challenging but well-organized with experienced guides, proper camping equipment, and safety protocols. Pacaya is easier and suitable for most fitness levels. Always book through established companies, follow guide instructions, and check current volcanic activity. Fuego volcano itself is off-limits due to active eruptions, but you can safely view it from Acatenango.'
    },
    {
      question: 'What are free things to do in Antigua Guatemala?',
      answer: 'Many of Antigua\'s best experiences are free: walking the colonial streets and photographing colorful buildings, visiting Santa Catalina Arch, exploring Central Park, hiking to Cerro de la Cruz viewpoint (go with others for safety), visiting church exteriors and ruins, browsing local markets, watching sunset from public plazas, and simply soaking in the atmosphere of colonial courtyards. The city itself is the attraction—you don\'t need to spend much to enjoy Antigua\'s beauty and culture.'
    },
    {
      question: 'How many days should I spend in Antigua Guatemala?',
      answer: 'Plan for at least 3 days in Antigua to experience the highlights without rushing. Two days works for a quick weekend trip covering the colonial center and one activity. Three days is ideal for most visitors, allowing time for city exploration, a volcano hike, and one day trip. Five days lets you dive deeper with multiple day trips, coffee tours, relaxation time, and a more immersive experience. Most US travelers find 3-4 days to be the sweet spot.'
    },
    {
      question: 'What is the best time of year to visit Antigua?',
      answer: 'The best time to visit Antigua is during the dry season from November to April, with peak season December through March offering the most reliable weather for volcano hikes and outdoor activities. Semana Santa (Holy Week in March or April) is spectacular but extremely crowded. The rainy season (May-October) brings afternoon showers but fewer tourists, lower prices, and lush green landscapes. For volcano hikes, dry season is strongly recommended for safety and visibility.'
    }
  ];

  // Combine all schemas into a single array for the SEO component
  const schemas = [
    // WebPage schema
    {
      "@context": "https://schema.org",
      "@type": "WebPage",
      "@id": "https://la-antigua-guatemala.com/things-to-do-in-antigua-guatemala#webpage",
      "name": "25 Best Things to Do in Antigua Guatemala (2026) + Map & Tips",
      "description": "Best things to do in Antigua Guatemala (2026): Santa Catalina Arch, Cerro de la Cruz, coffee tours, markets, Pacaya & Acatenango. Includes free things, day trips, costs, and safety tips.",
      "url": "https://la-antigua-guatemala.com/things-to-do-in-antigua-guatemala",
      "inLanguage": "en-US",
      "dateModified": "2026-02-20",
      "publisher": {
        "@type": "Organization",
        "name": "La Antigua Guatemala",
        "url": "https://la-antigua-guatemala.com/"
      },
      "isPartOf": {
        "@type": "WebSite",
        "name": "La Antigua Guatemala",
        "url": "https://la-antigua-guatemala.com/"
      },
      "breadcrumb": {
        "@type": "BreadcrumbList",
        "itemListElement": [
          {
            "@type": "ListItem",
            "position": 1,
            "name": "Home",
            "item": "https://la-antigua-guatemala.com/"
          },
          {
            "@type": "ListItem",
            "position": 2,
            "name": "Things to Do",
            "item": "https://la-antigua-guatemala.com/things-to-do-in-antigua-guatemala"
          }
        ]
      },
      "mainEntity": {
        "@type": "ItemList",
        "name": "Best Things to Do in Antigua Guatemala",
        "itemListElement": [
          { "@type": "ListItem", "position": 1, "name": "Santa Catalina Arch", "url": "https://la-antigua-guatemala.com/things-to-do-in-antigua-guatemala#santa-catalina-arch" },
          { "@type": "ListItem", "position": 2, "name": "La Merced Church", "url": "https://la-antigua-guatemala.com/things-to-do-in-antigua-guatemala#la-merced-church" },
          { "@type": "ListItem", "position": 3, "name": "Antigua Cathedral Ruins", "url": "https://la-antigua-guatemala.com/things-to-do-in-antigua-guatemala#antigua-cathedral-ruins" },
          { "@type": "ListItem", "position": 4, "name": "Convento de las Capuchinas", "url": "https://la-antigua-guatemala.com/things-to-do-in-antigua-guatemala#convento-capuchinas" },
          { "@type": "ListItem", "position": 5, "name": "Central Park", "url": "https://la-antigua-guatemala.com/things-to-do-in-antigua-guatemala#central-park" },
          { "@type": "ListItem", "position": 6, "name": "Acatenango Volcano Hike", "url": "https://la-antigua-guatemala.com/things-to-do-in-antigua-guatemala#acatenango-volcano-hike" },
          { "@type": "ListItem", "position": 7, "name": "Pacaya Volcano Day Trip", "url": "https://la-antigua-guatemala.com/things-to-do-in-antigua-guatemala#pacaya-volcano" },
          { "@type": "ListItem", "position": 8, "name": "Cerro de la Cruz Viewpoint", "url": "https://la-antigua-guatemala.com/things-to-do-in-antigua-guatemala#cerro-de-la-cruz" },
          { "@type": "ListItem", "position": 9, "name": "Coffee Farm Tours", "url": "https://la-antigua-guatemala.com/things-to-do-in-antigua-guatemala#coffee-farm-tours" },
          { "@type": "ListItem", "position": 10, "name": "Chocolate Making Workshops", "url": "https://la-antigua-guatemala.com/things-to-do-in-antigua-guatemala#chocolate-workshops" },
          { "@type": "ListItem", "position": 11, "name": "Local Markets & Street Food", "url": "https://la-antigua-guatemala.com/things-to-do-in-antigua-guatemala#local-markets" },
          { "@type": "ListItem", "position": 12, "name": "Rooftop Restaurants", "url": "https://la-antigua-guatemala.com/things-to-do-in-antigua-guatemala#rooftop-restaurants" },
          { "@type": "ListItem", "position": 13, "name": "Lake Atitlán Day Trip", "url": "https://la-antigua-guatemala.com/things-to-do-in-antigua-guatemala#day-trips" },
          { "@type": "ListItem", "position": 14, "name": "Chichicastenango Market", "url": "https://la-antigua-guatemala.com/things-to-do-in-antigua-guatemala#day-trips" },
          { "@type": "ListItem", "position": 15, "name": "Hobbitenango", "url": "https://la-antigua-guatemala.com/things-to-do-in-antigua-guatemala#day-trips" },
          { "@type": "ListItem", "position": 16, "name": "Iximché Mayan Ruins", "url": "https://la-antigua-guatemala.com/things-to-do-in-antigua-guatemala#day-trips" },
          { "@type": "ListItem", "position": 17, "name": "ATV Tours Through Coffee Plantations", "url": "https://la-antigua-guatemala.com/things-to-do-in-antigua-guatemala#outdoor-adventure" },
          { "@type": "ListItem", "position": 18, "name": "Spanish Language Classes", "url": "https://la-antigua-guatemala.com/things-to-do-in-antigua-guatemala#rainy-day" },
          { "@type": "ListItem", "position": 19, "name": "Walking the Colonial Streets", "url": "https://la-antigua-guatemala.com/things-to-do-in-antigua-guatemala#free-things" },
          { "@type": "ListItem", "position": 20, "name": "Sunset from Public Plazas", "url": "https://la-antigua-guatemala.com/things-to-do-in-antigua-guatemala#free-things" },
          { "@type": "ListItem", "position": 21, "name": "Live Music & Bars", "url": "https://la-antigua-guatemala.com/things-to-do-in-antigua-guatemala#night-activities" },
          { "@type": "ListItem", "position": 22, "name": "Evening Church Visits", "url": "https://la-antigua-guatemala.com/things-to-do-in-antigua-guatemala#night-activities" },
          { "@type": "ListItem", "position": 23, "name": "Agua Volcano Summit Hike", "url": "https://la-antigua-guatemala.com/things-to-do-in-antigua-guatemala#outdoor-adventure" },
          { "@type": "ListItem", "position": 24, "name": "Monterrico Black Sand Beaches", "url": "https://la-antigua-guatemala.com/things-to-do-in-antigua-guatemala#day-trips" },
          { "@type": "ListItem", "position": 25, "name": "Photography Walks", "url": "https://la-antigua-guatemala.com/things-to-do-in-antigua-guatemala#free-things" }
        ]
      }
    },
    // FAQPage schema
    {
      "@context": "https://schema.org",
      "@type": "FAQPage",
      "url": "https://la-antigua-guatemala.com/things-to-do-in-antigua-guatemala",
      "mainEntityOfPage": "https://la-antigua-guatemala.com/things-to-do-in-antigua-guatemala",
      "mainEntity": faqs.map(faq => ({
        "@type": "Question",
        "name": faq.question,
        "acceptedAnswer": {
          "@type": "Answer",
          "text": faq.answer
        }
      }))
    },
    // Article schema
    {
      "@context": "https://schema.org",
      "@type": "Article",
      "headline": "25 Best Things to Do in Antigua Guatemala (2026) + Map & Tips",
      "description": "Best things to do in Antigua Guatemala (2026): Santa Catalina Arch, Cerro de la Cruz, coffee tours, markets, Pacaya & Acatenango. Includes free things, day trips, costs, and safety tips.",
      "mainEntityOfPage": {
        "@id": "https://la-antigua-guatemala.com/things-to-do-in-antigua-guatemala#webpage"
      },
      "datePublished": "2025-06-01",
      "dateModified": "2026-02-20",
      "inLanguage": "en-US",
      "author": {
        "@type": "Organization",
        "name": "La Antigua Guatemala travel team"
      },
      "publisher": {
        "@type": "Organization",
        "name": "La Antigua Guatemala",
        "url": "https://la-antigua-guatemala.com/",
        "logo": {
          "@type": "ImageObject",
          "url": "https://la-antigua-guatemala.com/og/things-to-do.jpg",
          "width": 1200,
          "height": 630
        }
      },
      "image": {
        "@type": "ImageObject",
        "url": "https://la-antigua-guatemala.com/og/things-to-do.jpg",
        "width": 1200,
        "height": 630
      }
    }
  ];

  return (
    <div className="min-h-screen bg-white">
      <SEO 
        title="25 Best Things to Do in Antigua Guatemala (2026) + Map & Tips"
        description="Best things to do in Antigua Guatemala (2026): Santa Catalina Arch, Cerro de la Cruz, coffee tours, markets, Pacaya & Acatenango. Includes free things, day trips, costs, and safety tips."
        canonical="https://la-antigua-guatemala.com/things-to-do-in-antigua-guatemala"
        type="article"
        schema={schemas}
        ogImage={{
          url: "https://la-antigua-guatemala.com/og/things-to-do.jpg",
          width: "1200",
          height: "630"
        }}
        lastModified="2026-02-20"
      />
      <Navbar darkText />
      
      {/* Hero Section */}
      <section className="relative h-auto md:h-[65vh] flex items-center justify-center pt-24 md:pt-20">
        <div className="absolute inset-0">
          <img 
            src="https://public.readdy.ai/ai/img_res/35b234080b1cd05d0c97cdad5b009d75.jpg"
            alt="Things to do in Antigua Guatemala"
            className="w-full h-full object-cover object-center"
          />
          <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/30 to-black/50"></div>
        </div>
        <div className="relative z-10 text-center text-white px-4 max-w-5xl mx-auto py-12 md:py-0 w-full">
          {/* Last updated badge */}
          <div className="inline-flex items-center gap-2 bg-white/20 backdrop-blur-sm text-white text-xs font-medium px-3 py-1.5 rounded-full mb-4">
            <i className="ri-refresh-line text-sm"></i>
            <span>Last updated: February 20, 2026</span>
          </div>
          <h1 className="text-3xl md:text-6xl font-bold mb-4 md:mb-6">25 Best Things to Do in Antigua Guatemala</h1>
          <p className="text-base md:text-2xl mb-6 md:mb-8">From volcano hikes to colonial landmarks, coffee tours to cultural experiences—your complete guide to Antigua's best attractions</p>
          <div className="flex flex-wrap gap-4 justify-center">
            <Link to="/plan-my-antigua-trip" className="bg-teal-500 hover:bg-teal-600 text-white px-8 py-4 rounded-lg font-semibold transition whitespace-nowrap cursor-pointer">
              Plan My Trip
            </Link>
            <Link to="/antigua-guatemala-itineraries" className="bg-white hover:bg-gray-100 text-gray-900 px-8 py-4 rounded-lg font-semibold transition whitespace-nowrap cursor-pointer">
              View Sample Itineraries
            </Link>
          </div>
        </div>
      </section>

      {/* Quick Answer Section */}
      <section className="py-16 bg-gray-50">
        <div className="max-w-4xl mx-auto px-4">
          <h2 className="text-3xl font-bold text-gray-900 mb-6">What Are the Best Things to Do in Antigua Guatemala?</h2>
          <p className="text-lg text-gray-700 mb-8">
            Antigua Guatemala offers an incredible mix of adventure, culture, and relaxation. Whether you're here for volcano hikes, colonial architecture, or authentic Guatemalan experiences, this UNESCO World Heritage city delivers unforgettable moments for US travelers.
          </p>

          {/* Quick List / Table of Contents */}
          <div className="bg-white p-6 rounded-lg shadow-sm mb-8">
            <h3 className="text-xl font-bold text-gray-900 mb-4">Quick List: Top 15 Things to Do</h3>
            <div className="grid md:grid-cols-2 gap-3">
              <a href="#santa-catalina-arch" className="text-teal-500 hover:text-teal-600 flex items-center gap-2 cursor-pointer">
                <i className="ri-arrow-right-s-line"></i>
                <span>Santa Catalina Arch</span>
              </a>
              <a href="#acatenango-volcano-hike" className="text-teal-500 hover:text-teal-600 flex items-center gap-2 cursor-pointer">
                <i className="ri-arrow-right-s-line"></i>
                <span>Acatenango Volcano Hike</span>
              </a>
              <a href="#la-merced-church" className="text-teal-500 hover:text-teal-600 flex items-center gap-2 cursor-pointer">
                <i className="ri-arrow-right-s-line"></i>
                <span>La Merced Church</span>
              </a>
              <a href="#pacaya-volcano" className="text-teal-500 hover:text-teal-600 flex items-center gap-2 cursor-pointer">
                <i className="ri-arrow-right-s-line"></i>
                <span>Pacaya Volcano Day Trip</span>
              </a>
              <a href="#cerro-de-la-cruz" className="text-teal-500 hover:text-teal-600 flex items-center gap-2 cursor-pointer">
                <i className="ri-arrow-right-s-line"></i>
                <span>Cerro de la Cruz Viewpoint</span>
              </a>
              <a href="#coffee-farm-tours" className="text-teal-500 hover:text-teal-600 flex items-center gap-2 cursor-pointer">
                <i className="ri-arrow-right-s-line"></i>
                <span>Coffee Farm Tours</span>
              </a>
              <a href="#antigua-cathedral-ruins" className="text-teal-500 hover:text-teal-600 flex items-center gap-2 cursor-pointer">
                <i className="ri-arrow-right-s-line"></i>
                <span>Cathedral Ruins</span>
              </a>
              <a href="#chocolate-workshops" className="text-teal-500 hover:text-teal-600 flex items-center gap-2 cursor-pointer">
                <i className="ri-arrow-right-s-line"></i>
                <span>Chocolate Workshops</span>
              </a>
              <a href="#convento-capuchinas" className="text-teal-500 hover:text-teal-600 flex items-center gap-2 cursor-pointer">
                <i className="ri-arrow-right-s-line"></i>
                <span>Convento de las Capuchinas</span>
              </a>
              <a href="#local-markets" className="text-teal-500 hover:text-teal-600 flex items-center gap-2 cursor-pointer">
                <i className="ri-arrow-right-s-line"></i>
                <span>Local Markets & Street Food</span>
              </a>
              <a href="#central-park" className="text-teal-500 hover:text-teal-600 flex items-center gap-2 cursor-pointer">
                <i className="ri-arrow-right-s-line"></i>
                <span>Central Park</span>
              </a>
              <a href="#rooftop-restaurants" className="text-teal-500 hover:text-teal-600 flex items-center gap-2 cursor-pointer">
                <i className="ri-arrow-right-s-line"></i>
                <span>Rooftop Restaurants</span>
              </a>
              <a href="#day-trips" className="text-teal-500 hover:text-teal-600 flex items-center gap-2 cursor-pointer">
                <i className="ri-arrow-right-s-line"></i>
                <span>Lake Atitlán Day Trip</span>
              </a>
              <a href="#day-trips" className="text-teal-500 hover:text-teal-600 flex items-center gap-2 cursor-pointer">
                <i className="ri-arrow-right-s-line"></i>
                <span>Chichicastenango Market</span>
              </a>
              <a href="#day-trips" className="text-teal-500 hover:text-teal-600 flex items-center gap-2 cursor-pointer">
                <i className="ri-arrow-right-s-line"></i>
                <span>Hobbitenango</span>
              </a>
            </div>
          </div>

          {/* Table of Contents */}
          <div className="bg-teal-50 p-6 rounded-lg">
            <h3 className="text-xl font-bold text-gray-900 mb-4">Jump to Section</h3>
            <div className="grid md:grid-cols-2 gap-3">
              <a href="#historical-cultural" className="text-teal-600 hover:text-teal-700 font-semibold flex items-center gap-2 cursor-pointer">
                <i className="ri-building-line"></i>
                <span>Historical &amp; Cultural Attractions</span>
              </a>
              <a href="#outdoor-adventure" className="text-teal-600 hover:text-teal-700 font-semibold flex items-center gap-2 cursor-pointer">
                <i className="ri-mountain-line"></i>
                <span>Outdoor &amp; Adventure Activities</span>
              </a>
              <a href="#coffee-food" className="text-teal-600 hover:text-teal-700 font-semibold flex items-center gap-2 cursor-pointer">
                <i className="ri-cup-line"></i>
                <span>Coffee &amp; Food Experiences</span>
              </a>
              <a href="#day-trips" className="text-teal-600 hover:text-teal-700 font-semibold flex items-center gap-2 cursor-pointer">
                <i className="ri-map-pin-line"></i>
                <span>Best Day Trips</span>
              </a>
              <a href="#free-things" className="text-teal-600 hover:text-teal-700 font-semibold flex items-center gap-2 cursor-pointer">
                <i className="ri-gift-line"></i>
                <span>Free Things to Do</span>
              </a>
              <a href="#night-activities" className="text-teal-600 hover:text-teal-700 font-semibold flex items-center gap-2 cursor-pointer">
                <i className="ri-moon-line"></i>
                <span>Things to Do at Night</span>
              </a>
              <a href="#rainy-day" className="text-teal-600 hover:text-teal-700 font-semibold flex items-center gap-2 cursor-pointer">
                <i className="ri-umbrella-line"></i>
                <span>Rainy Day Activities</span>
              </a>
              <a href="#safety-timing" className="text-teal-600 hover:text-teal-700 font-semibold flex items-center gap-2 cursor-pointer">
                <i className="ri-shield-check-line"></i>
                <span>Safety &amp; Best Time</span>
              </a>
            </div>
          </div>

          <div className="grid md:grid-cols-2 gap-4 mt-8">
            {activities.map((activity, index) => (
              <Link 
                key={index}
                to={activity.link}
                className="bg-white p-5 rounded-lg shadow-sm hover:shadow-md transition cursor-pointer group"
              >
                <div className="flex items-start gap-4">
                  <div className="w-12 h-12 flex items-center justify-center bg-teal-50 text-teal-500 rounded-lg text-2xl flex-shrink-0">
                    <i className={activity.icon}></i>
                  </div>
                  <div className="flex-1">
                    <h3 className="font-semibold text-gray-900 mb-2 group-hover:text-teal-500 transition">{activity.title}</h3>
                    <div className="flex flex-wrap gap-2 text-sm text-gray-600">
                      <span className="bg-gray-100 px-2 py-1 rounded">{activity.category}</span>
                      <span className="bg-gray-100 px-2 py-1 rounded">{activity.time}</span>
                      <span className="bg-gray-100 px-2 py-1 rounded">{activity.cost}</span>
                    </div>
                  </div>
                </div>
              </Link>
            ))}
          </div>
        </div>
      </section>

      {/* Introduction */}
      <section className="py-16">
        <div className="max-w-4xl mx-auto px-4">
          <div className="prose prose-lg max-w-none">
            <p className="text-xl text-gray-700 leading-relaxed">
              Planning what to do in Antigua Guatemala? You're in for a treat. This colonial gem offers everything from challenging <Link to="/acatenango-hike-from-antigua" className="text-teal-500 hover:text-teal-600 font-semibold cursor-pointer">volcano hikes</Link> with views of active eruptions to peaceful coffee farm tours, vibrant indigenous markets, and some of the most photogenic Spanish colonial architecture in the Americas. Located just 45 minutes from Guatemala City airport, Antigua is the perfect base for US travelers seeking adventure, culture, and authentic experiences in Central America.
            </p>
          </div>
        </div>
      </section>

      {/* Historical & Cultural Attractions */}
      <section id="historical-cultural" className="py-16 bg-white">
        <div className="max-w-6xl mx-auto px-4">
          <h2 className="text-4xl font-bold text-gray-900 mb-12">Best Historical &amp; Cultural Attractions</h2>
          
          <div className="space-y-12">
            {/* Santa Catalina Arch */}
            <div id="santa-catalina-arch" className="grid md:grid-cols-2 gap-8 items-center">
              <div>
                <h3 className="text-2xl font-bold text-gray-900 mb-4">Santa Catalina Arch</h3>
                <p className="text-gray-700 mb-4">
                  The iconic yellow arch spanning 5th Avenue Norte is Antigua's most photographed landmark. Built in 1694 to connect the Santa Catalina convent, allowing nuns to cross the street without being seen, this baroque masterpiece perfectly frames Agua volcano in the background.
                </p>
                <p className="text-gray-700 mb-4">
                  <strong className="text-gray-900">Why visit:</strong> It's the quintessential Antigua photo opportunity, especially at golden hour when the yellow facade glows against the volcano backdrop. The arch is centrally located, making it easy to include in any walking tour of the colonial center.
                </p>
                <div className="flex flex-wrap gap-3 text-sm">
                  <span className="bg-gray-100 px-3 py-1 rounded-full text-gray-700"><strong>Time needed:</strong> 15-30 minutes</span>
                  <span className="bg-gray-100 px-3 py-1 rounded-full text-gray-700"><strong>Cost:</strong> Free</span>
                  <span className="bg-gray-100 px-3 py-1 rounded-full text-gray-700"><strong>Best for:</strong> Everyone</span>
                </div>
              </div>
              <div className="w-full h-80">
                <img 
                  src="https://readdy.ai/api/search-image?query=Santa%20Catalina%20Arch%20Antigua%20Guatemala%20iconic%20yellow%20arch%20with%20Agua%20volcano%20background%2C%20colonial%20Spanish%20architecture%2C%20cobblestone%20street%2C%20vibrant%20yellow%20color%2C%20golden%20hour%20lighting%2C%20travel%20landmark%20photography&width=800&height=600&seq=santa-catalina-arch&orientation=landscape"
                  alt="Santa Catalina Arch in Antigua Guatemala"
                  className="w-full h-full object-cover object-center rounded-lg shadow-md"
                  loading="lazy"
                  decoding="async"
                />
              </div>
            </div>

            {/* La Merced Church */}
            <div id="la-merced-church" className="grid md:grid-cols-2 gap-8 items-center">
              <div className="order-2 md:order-1 w-full h-80">
                <img 
                  src="https://readdy.ai/api/search-image?query=La%20Merced%20Church%20Antigua%20Guatemala%20baroque%20yellow%20facade%2C%20ornate%20colonial%20Spanish%20architecture%2C%20detailed%20religious%20sculptures%2C%20vibrant%20yellow%20and%20white%20colors%2C%20architectural%20photography%2C%20clear%20blue%20sky&width=800&height=600&seq=la-merced-church&orientation=landscape"
                  alt="La Merced Church Antigua"
                  className="w-full h-full object-cover object-center rounded-lg shadow-md"
                  loading="lazy"
                  decoding="async"
                />
              </div>
              <div className="order-1 md:order-2">
                <h3 className="text-2xl font-bold text-gray-900 mb-4">La Merced Church</h3>
                <p className="text-gray-700 mb-4">
                  This stunning baroque church features one of the most elaborate facades in Antigua, with intricate yellow and white stucco work depicting religious scenes. Built in the 18th century, La Merced survived multiple earthquakes and remains one of the city's most beautiful active churches.
                </p>
                <p className="text-gray-700 mb-4">
                  <strong className="text-gray-900">Why visit:</strong> The ornate facade is a masterpiece of colonial baroque architecture. Inside, you'll find a peaceful courtyard and the largest fountain in Central America. The church is particularly photogenic in morning light.
                </p>
                <div className="flex flex-wrap gap-3 text-sm">
                  <span className="bg-gray-100 px-3 py-1 rounded-full text-gray-700"><strong>Time needed:</strong> 30-45 minutes</span>
                  <span className="bg-gray-100 px-3 py-1 rounded-full text-gray-700"><strong>Cost:</strong> Free (donations welcome)</span>
                  <span className="bg-gray-100 px-3 py-1 rounded-full text-gray-700"><strong>Best for:</strong> Architecture lovers</span>
                </div>
              </div>
            </div>

            {/* Antigua Cathedral Ruins */}
            <div id="antigua-cathedral-ruins" className="grid md:grid-cols-2 gap-8 items-center">
              <div>
                <h3 className="text-2xl font-bold text-gray-900 mb-4">Antigua Cathedral Ruins</h3>
                <p className="text-gray-700 mb-4">
                  The partially destroyed cathedral on the east side of Central Park is one of Antigua's most atmospheric attractions. Originally built in 1545 and destroyed multiple times, the ruins now offer a haunting glimpse into colonial grandeur with crumbling arches, exposed crypts, and weathered stone columns.
                </p>
                <p className="text-gray-700 mb-4">
                  <strong className="text-gray-900">Why visit:</strong> It's a powerful reminder of nature's force and colonial ambition. The ruins are atmospheric and photogenic, especially the underground crypts. It's less crowded than other attractions.
                </p>
                <div className="flex flex-wrap gap-3 text-sm">
                  <span className="bg-gray-100 px-3 py-1 rounded-full text-gray-700"><strong>Time needed:</strong> 45 minutes</span>
                  <span className="bg-gray-100 px-3 py-1 rounded-full text-gray-700"><strong>Cost:</strong> $5</span>
                  <span className="bg-gray-100 px-3 py-1 rounded-full text-gray-700"><strong>Best for:</strong> History enthusiasts</span>
                </div>
              </div>
              <div className="w-full h-80">
                <img 
                  src="https://readdy.ai/api/search-image?query=Antigua%20Cathedral%20ruins%20Guatemala%20colonial%20Spanish%20architecture%2C%20crumbling%20stone%20arches%2C%20weathered%20columns%2C%20historical%20ruins%2C%20dramatic%20shadows%2C%20architectural%20decay%2C%20heritage%20site%20photography&width=800&height=600&seq=cathedral-ruins&orientation=landscape"
                  alt="Antigua Cathedral Ruins"
                  className="w-full h-full object-cover object-center rounded-lg shadow-md"
                  loading="lazy"
                  decoding="async"
                />
              </div>
            </div>

            {/* Convento Capuchinas */}
            <div id="convento-capuchinas" className="grid md:grid-cols-2 gap-8 items-center">
              <div className="order-2 md:order-1 w-full h-80">
                <img 
                  src="https://readdy.ai/api/search-image?query=Convento%20Capuchinas%20Antigua%20Guatemala%20circular%20tower%2C%20colonial%20convent%20architecture%2C%20stone%20arches%2C%20peaceful%20courtyard%2C%20historical%20monastery%2C%20architectural%20photography%2C%20soft%20natural%20lighting&width=800&height=600&seq=convento-capuchinas&orientation=landscape"
                  alt="Convento Capuchinas Antigua"
                  className="w-full h-full object-cover object-center rounded-lg shadow-md"
                  loading="lazy"
                  decoding="async"
                />
              </div>
              <div className="order-1 md:order-2">
                <h3 className="text-2xl font-bold text-gray-900 mb-4">Convento de las Capuchinas</h3>
                <p className="text-gray-700 mb-4">
                  This 18th-century convent is one of Antigua's best-preserved colonial buildings. The unique circular tower with 18 cells arranged around a central patio showcases innovative colonial architecture. The convent operated for only 28 years before the 1773 earthquake forced its abandonment.
                </p>
                <p className="text-gray-700 mb-4">
                  <strong className="text-gray-900">Why visit:</strong> The architecture is fascinating—the circular tower design is unique in colonial America. The peaceful courtyards and well-preserved structure offer insight into convent life. It's less crowded than other attractions.
                </p>
                <div className="flex flex-wrap gap-3 text-sm">
                  <span className="bg-gray-100 px-3 py-1 rounded-full text-gray-700"><strong>Time needed:</strong> 1 hour</span>
                  <span className="bg-gray-100 px-3 py-1 rounded-full text-gray-700"><strong>Cost:</strong> $5</span>
                  <span className="bg-gray-100 px-3 py-1 rounded-full text-gray-700"><strong>Best for:</strong> Architecture &amp; history buffs</span>
                </div>
              </div>
            </div>

            {/* Central Park */}
            <div id="central-park" className="bg-gray-50 p-8 rounded-lg">
              <h3 className="text-2xl font-bold text-gray-900 mb-4">Central Park (Parque Central)</h3>
              <p className="text-gray-700 mb-4">
                The heart of Antigua, Central Park is surrounded by colonial buildings, restaurants, and the cathedral. The park features a central fountain, shaded benches, and is the perfect spot for people-watching, starting walking tours, or simply soaking in the colonial atmosphere.
              </p>
              <p className="text-gray-700 mb-4">
                <strong className="text-gray-900">Why visit:</strong> It's the social and geographic center of Antigua. Great for orientation on your first day, meeting locals, and experiencing daily life. The park comes alive in the evening with street vendors, families, and tourists.
              </p>
              <div className="flex flex-wrap gap-3 text-sm">
                <span className="bg-white px-3 py-1 rounded-full text-gray-700"><strong>Time needed:</strong> 30 minutes - 1 hour</span>
                <span className="bg-white px-3 py-1 rounded-full text-gray-700"><strong>Cost:</strong> Free</span>
                <span className="bg-white px-3 py-1 rounded-full text-gray-700"><strong>Best for:</strong> Everyone</span>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Outdoor & Adventure Activities */}
      <section id="outdoor-adventure" className="py-16 bg-gray-50">
        <div className="max-w-6xl mx-auto px-4">
          <h2 className="text-4xl font-bold text-gray-900 mb-12">Best Outdoor &amp; Adventure Activities</h2>
          
          <div className="space-y-12">
            {/* Acatenango Hike */}
            <div id="acatenango-volcano-hike" className="grid md:grid-cols-2 gap-8 items-center">
              <div>
                <h3 className="text-2xl font-bold text-gray-900 mb-4">Acatenango Volcano Hike</h3>
                <p className="text-gray-700 mb-4">
                  The most iconic adventure in Guatemala. This challenging overnight hike takes you to 13,045 feet for front-row views of Fuego volcano erupting every 15-20 minutes. Camp at the summit, watch lava explosions light up the night sky, and witness an unforgettable sunrise over the volcanic landscape.
                </p>
                <p className="text-gray-700 mb-4">
                  <strong className="text-gray-900">Why do it:</strong> It's a bucket-list experience that rivals anything in South America. The combination of physical challenge, dramatic scenery, and active volcanic eruptions creates memories that last a lifetime. Most US travelers rank this as their top Guatemala experience.
                </p>
                <p className="text-gray-700 mb-4">
                  <strong className="text-gray-900">Difficulty:</strong> Challenging. Requires good fitness, proper gear, and mental preparation for cold temperatures and altitude. Tours provide camping equipment, meals, and experienced guides.
                </p>
                <div className="flex flex-wrap gap-3 text-sm mb-4">
                  <span className="bg-white px-3 py-1 rounded-full text-gray-700"><strong>Time needed:</strong> 2 days / 1 night</span>
                  <span className="bg-white px-3 py-1 rounded-full text-gray-700"><strong>Cost:</strong> $50-80</span>
                  <span className="bg-white px-3 py-1 rounded-full text-gray-700"><strong>Best season:</strong> Nov-Apr</span>
                </div>
                <Link to="/acatenango-hike-from-antigua" className="inline-block bg-teal-500 hover:bg-teal-600 text-white px-6 py-3 rounded-lg font-semibold transition whitespace-nowrap cursor-pointer">
                  Complete Acatenango Guide
                </Link>
              </div>
              <div className="w-full h-96">
                <img 
                  src="https://readdy.ai/api/search-image?query=Acatenango%20volcano%20hike%20Guatemala%20camping%20tents%20at%20summit%20with%20erupting%20Fuego%20volcano%2C%20dramatic%20lava%20explosions%2C%20night%20sky%20with%20stars%2C%20adventure%20travel%20photography%2C%20orange%20and%20red%20volcanic%20glow&width=800&height=700&seq=acatenango-hike-main&orientation=landscape"
                  alt="Acatenango volcano hike with Fuego eruptions"
                  className="w-full h-full object-cover object-center rounded-lg shadow-md"
                  loading="lazy"
                  decoding="async"
                />
              </div>
            </div>

            {/* Pacaya Volcano */}
            <div id="pacaya-volcano" className="grid md:grid-cols-2 gap-8 items-center">
              <div className="order-2 md:order-1 w-full h-96">
                <img 
                  src="https://readdy.ai/api/search-image?query=Pacaya%20volcano%20Guatemala%20day%20hike%2C%20hikers%20on%20volcanic%20landscape%2C%20black%20lava%20rocks%2C%20active%20volcano%20steam%20vents%2C%20dramatic%20volcanic%20terrain%2C%20adventure%20travel%20photography%2C%20clear%20blue%20sky&width=800&height=700&seq=pacaya-volcano-hike&orientation=landscape"
                  alt="Pacaya volcano day hike"
                  className="w-full h-full object-cover object-center rounded-lg shadow-md"
                  loading="lazy"
                  decoding="async"
                />
              </div>
              <div className="order-1 md:order-2">
                <h3 className="text-2xl font-bold text-gray-900 mb-4">Pacaya Volcano Day Trip</h3>
                <p className="text-gray-700 mb-4">
                  A more accessible volcano experience perfect for those who want adventure without the extreme challenge of Acatenango. This active volcano offers a moderate 2-hour hike through lava fields to areas where you can roast marshmallows over volcanic heat vents and see steam rising from recent lava flows.
                </p>
                <p className="text-gray-700 mb-4">
                  <strong className="text-gray-900">Why do it:</strong> It's the perfect middle ground—adventurous but doable for most fitness levels. You'll experience an active volcano up close, walk on hardened lava, and enjoy panoramic views without the overnight commitment.
                </p>
                <p className="text-gray-700 mb-4">
                  <strong className="text-gray-900">Difficulty:</strong> Moderate. The hike is steady uphill but manageable for anyone with basic fitness. Tours include transportation, guide, and entrance fees.
                </p>
                <div className="flex flex-wrap gap-3 text-sm mb-4">
                  <span className="bg-white px-3 py-1 rounded-full text-gray-700"><strong>Time needed:</strong> 6 hours (half day)</span>
                  <span className="bg-white px-3 py-1 rounded-full text-gray-700"><strong>Cost:</strong> $30-40</span>
                  <span className="bg-white px-3 py-1 rounded-full text-gray-700"><strong>Best for:</strong> Families &amp; moderate hikers</span>
                </div>
                <Link to="/antigua-guatemala-itineraries" className="inline-block text-teal-500 hover:text-teal-600 font-semibold cursor-pointer">
                  See All Day Trips →
                </Link>
              </div>
            </div>

            {/* Cerro de la Cruz */}
            <div id="cerro-de-la-cruz" className="grid md:grid-cols-2 gap-8 items-center">
              <div>
                <h3 className="text-2xl font-bold text-gray-900 mb-4">Cerro de la Cruz Viewpoint</h3>
                <p className="text-gray-700 mb-4">
                  A short but steep 20-minute hike north of the city center leads to this hilltop cross with panoramic views over Antigua's red-tiled roofs and the surrounding volcanoes. It's the best free viewpoint in Antigua and perfect for sunset photography.
                </p>
                <p className="text-gray-700 mb-4">
                  <strong className="text-gray-900">Why do it:</strong> The views are spectacular and it's completely free. You'll get a bird's-eye perspective of the colonial grid layout with Agua volcano as the backdrop. It's also a great warm-up hike if you're preparing for Acatenango.
                </p>
                <p className="text-gray-700 mb-4">
                  <strong className="text-gray-900">Safety note:</strong> Go in a group or during busy hours (morning or late afternoon). While generally safe, the trail has had occasional robbery reports. Many hotels organize group hikes.
                </p>
                <div className="flex flex-wrap gap-3 text-sm">
                  <span className="bg-white px-3 py-1 rounded-full text-gray-700"><strong>Time needed:</strong> 1 hour round trip</span>
                  <span className="bg-white px-3 py-1 rounded-full text-gray-700"><strong>Cost:</strong> Free</span>
                  <span className="bg-white px-3 py-1 rounded-full text-gray-700"><strong>Difficulty:</strong> Easy-moderate</span>
                </div>
              </div>
              <div className="w-full h-80">
                <img 
                  src="https://readdy.ai/api/search-image?query=Cerro%20de%20la%20Cruz%20viewpoint%20Antigua%20Guatemala%20panoramic%20city%20view%2C%20colonial%20rooftops%2C%20Agua%20volcano%20background%2C%20cross%20monument%2C%20sunset%20golden%20hour%20lighting%2C%20landscape%20photography&width=800&height=600&seq=cerro-cruz-viewpoint&orientation=landscape"
                  alt="Cerro de la Cruz viewpoint Antigua"
                  className="w-full h-full object-cover object-center rounded-lg shadow-md"
                  loading="lazy"
                  decoding="async"
                />
              </div>
            </div>

            {/* ATV Tours */}
            <div className="bg-white p-8 rounded-lg shadow-sm">
              <div className="grid md:grid-cols-2 gap-8 items-center">
                <div>
                  <h3 className="text-2xl font-bold text-gray-900 mb-4">ATV Tours Through Coffee Plantations</h3>
                  <p className="text-gray-700 mb-4">
                    Explore the countryside around Antigua on guided ATV tours through coffee plantations, traditional villages, and mountain trails. These tours combine adventure with cultural immersion, often including stops at local farms and viewpoints.
                  </p>
                  <p className="text-gray-700 mb-4">
                    <strong className="text-gray-900">Why do it:</strong> Coffee lovers will appreciate seeing the entire process from plant to cup. The tours are educational, the settings are beautiful (often with volcano views), and you'll taste exceptional coffee. Many tours include traditional Guatemalan lunch.
                  </p>
                  <div className="flex flex-wrap gap-3 text-sm">
                    <span className="bg-gray-50 px-3 py-1 rounded-full text-gray-700"><strong>Time needed:</strong> 3-4 hours</span>
                    <span className="bg-gray-50 px-3 py-1 rounded-full text-gray-700"><strong>Cost:</strong> $25-40</span>
                    <span className="bg-gray-50 px-3 py-1 rounded-full text-gray-700"><strong>Best for:</strong> Coffee enthusiasts</span>
                  </div>
                </div>
                <div className="w-full h-80">
                  <img 
                    src="https://readdy.ai/api/search-image?query=Guatemala%20coffee%20farm%20tour%20Antigua%2C%20coffee%20plants%20with%20red%20cherries%2C%20volcanic%20mountain%20background%2C%20traditional%20coffee%20processing%2C%20agricultural%20tourism%2C%20lush%20green%20plantation%2C%20warm%20natural%20lighting&width=800&height=600&seq=coffee-farm-tour&orientation=landscape"
                    alt="Coffee farm tour near Antigua"
                    className="w-full h-full object-cover object-center rounded-lg shadow-md"
                    loading="lazy"
                    decoding="async"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* CTA Section - Mid Page */}
      <section className="py-16 bg-teal-500">
        <div className="max-w-4xl mx-auto px-4 text-center">
          <h2 className="text-3xl font-bold text-white mb-4">Need Help Planning Your Antigua Itinerary?</h2>
          <p className="text-lg text-white/90 mb-8">Get personalized recommendations for activities, tours, and hotels based on your interests and travel dates.</p>
          <Link to="/plan-my-antigua-trip" className="inline-block bg-white hover:bg-gray-100 text-teal-500 px-8 py-4 rounded-lg font-semibold text-lg transition whitespace-nowrap cursor-pointer">
            Plan My Trip
          </Link>
        </div>
      </section>

      {/* Coffee & Food Experiences */}
      <section id="coffee-food" className="py-16 bg-white">
        <div className="max-w-6xl mx-auto px-4">
          <h2 className="text-4xl font-bold text-gray-900 mb-12">Best Coffee &amp; Food Experiences</h2>
          
          <div className="space-y-12">
            {/* Coffee Farm Tours */}
            <div id="coffee-farm-tours" className="grid md:grid-cols-2 gap-8 items-center">
              <div>
                <h3 className="text-2xl font-bold text-gray-900 mb-4">Coffee Farm Tours</h3>
                <p className="text-gray-700 mb-4">
                  Guatemala produces some of the world's finest coffee, and Antigua's volcanic soil creates particularly prized beans. Tour working coffee plantations to learn about cultivation, processing, roasting, and tasting. Popular farms include Finca Filadelfia, Finca La Azotea, and Cafetenango.
                </p>
                <p className="text-gray-700 mb-4">
                  <strong className="text-gray-900">Why do it:</strong> Coffee lovers will appreciate seeing the entire process from plant to cup. The tours are educational, the settings are beautiful (often with volcano views), and you'll taste exceptional coffee. Many tours include traditional Guatemalan lunch.
                </p>
                <p className="text-gray-700 mb-4">
                  <strong className="text-gray-900">Best time:</strong> Harvest season (November-March) offers the most comprehensive experience, but tours run year-round.
                </p>
                <div className="flex flex-wrap gap-3 text-sm">
                  <span className="bg-gray-50 px-3 py-1 rounded-full text-gray-700"><strong>Time needed:</strong> 3-4 hours</span>
                  <span className="bg-gray-50 px-3 py-1 rounded-full text-gray-700"><strong>Cost:</strong> $25-40</span>
                  <span className="bg-gray-50 px-3 py-1 rounded-full text-gray-700"><strong>Best for:</strong> Coffee enthusiasts</span>
                </div>
              </div>
              <div className="w-full h-80">
                <img 
                  src="https://readdy.ai/api/search-image?query=Guatemala%20coffee%20farm%20tour%20Antigua%2C%20coffee%20plants%20with%20red%20cherries%2C%20volcanic%20mountain%20background%2C%20traditional%20coffee%20processing%2C%20agricultural%20tourism%2C%20lush%20green%20plantation%2C%20warm%20natural%20lighting&width=800&height=600&seq=coffee-farm-tour&orientation=landscape"
                  alt="Coffee farm tour near Antigua"
                  className="w-full h-full object-cover object-center rounded-lg shadow-md"
                  loading="lazy"
                  decoding="async"
                />
              </div>
            </div>

            {/* Chocolate Workshops */}
            <div id="chocolate-workshops" className="grid md:grid-cols-2 gap-8 items-center">
              <div className="order-2 md:order-1 w-full h-80">
                <img 
                  src="https://readdy.ai/api/search-image?query=Chocolate%20making%20workshop%20Guatemala%2C%20hands%20grinding%20cacao%20beans%2C%20traditional%20chocolate%20preparation%2C%20artisan%20chocolate%20process%2C%20cultural%20experience%2C%20warm%20brown%20tones%2C%20educational%20activity&width=800&height=600&seq=chocolate-workshop&orientation=landscape"
                  alt="Chocolate making workshop Antigua"
                  className="w-full h-full object-cover object-center rounded-lg shadow-md"
                  loading="lazy"
                  decoding="async"
                />
              </div>
              <div className="order-1 md:order-2">
                <h3 className="text-2xl font-bold text-gray-900 mb-4">Chocolate Making Workshops</h3>
                <p className="text-gray-700 mb-4">
                  Learn about Guatemala's ancient Mayan chocolate traditions in hands-on workshops. You'll roast cacao beans, grind them on traditional stone metates, and create your own chocolate bars with custom flavors. ChocoMuseo and other shops offer daily classes.
                </p>
                <p className="text-gray-700 mb-4">
                  <strong className="text-gray-900">Why do it:</strong> It's interactive, educational, and delicious. You'll learn about Mayan history, chocolate's cultural significance, and the difference between industrial and artisan chocolate. Plus, you take home your creations.
                </p>
                <div className="flex flex-wrap gap-3 text-sm">
                  <span className="bg-gray-50 px-3 py-1 rounded-full text-gray-700"><strong>Time needed:</strong> 2 hours</span>
                  <span className="bg-gray-50 px-3 py-1 rounded-full text-gray-700"><strong>Cost:</strong> $20-30</span>
                  <span className="bg-gray-50 px-3 py-1 rounded-full text-gray-700"><strong>Best for:</strong> Families &amp; foodies</span>
                </div>
              </div>
            </div>

            {/* Local Markets */}
            <div id="local-markets" className="bg-gray-50 p-8 rounded-lg">
              <h3 className="text-2xl font-bold text-gray-900 mb-4">Local Markets &amp; Street Food</h3>
              <p className="text-gray-700 mb-4">
                Experience authentic Guatemalan food culture at Antigua's markets. The Mercado Central offers fresh produce, traditional textiles, and local snacks. For street food, try the Mercado de Artesanías area where vendors sell tamales, tostadas, and fresh fruit.
              </p>
              <p className="text-gray-700 mb-4">
                <strong className="text-gray-900">Must-try foods:</strong> Pepián (traditional stew), chiles rellenos (stuffed peppers), tamales wrapped in banana leaves, fresh tortillas, and licuados (fruit smoothies).
              </p>
              <p className="text-gray-700 mb-4">
                <strong className="text-gray-900">Why visit:</strong> Markets are where locals shop and eat. You'll find the most authentic food at the lowest prices, plus it's a cultural experience. Go in the morning for the best selection.
              </p>
              <div className="flex flex-wrap gap-3 text-sm">
                <span className="bg-white px-3 py-1 rounded-full text-gray-700"><strong>Time needed:</strong> 1-2 hours</span>
                <span className="bg-white px-3 py-1 rounded-full text-gray-700"><strong>Cost:</strong> $5-10 for full meal</span>
                <span className="bg-white px-3 py-1 rounded-full text-gray-700"><strong>Best for:</strong> Adventurous eaters</span>
              </div>
            </div>

            {/* Rooftop Restaurants */}
            <div id="rooftop-restaurants" className="grid md:grid-cols-2 gap-8 items-center">
              <div>
                <h3 className="text-2xl font-bold text-gray-900 mb-4">Rooftop Restaurants &amp; Sunset Views</h3>
                <p className="text-gray-700 mb-4">
                  Antigua's rooftop restaurants offer stunning volcano views alongside excellent food. Popular spots include Café Sky, Sobremesa, and Restaurante Las Palmas. Watch the sunset paint Agua volcano orange while enjoying craft cocktails and fusion cuisine.
                </p>
                <p className="text-gray-700 mb-4">
                  <strong className="text-gray-900">Why go:</strong> The combination of colonial architecture, volcano views, and quality food creates memorable dining experiences. Sunset is magical—arrive by 5:30 PM to secure a good table.
                </p>
                <div className="flex flex-wrap gap-3 text-sm">
                  <span className="bg-gray-50 px-3 py-1 rounded-full text-gray-700"><strong>Time needed:</strong> 1.5-2 hours</span>
                  <span className="bg-gray-50 px-3 py-1 rounded-full text-gray-700"><strong>Cost:</strong> $15-30 per person</span>
                  <span className="bg-gray-50 px-3 py-1 rounded-full text-gray-700"><strong>Best for:</strong> Couples &amp; photographers</span>
                </div>
              </div>
              <div className="w-full h-80">
                <img 
                  src="https://readdy.ai/api/search-image?query=Rooftop%20restaurant%20Antigua%20Guatemala%20sunset%20view%2C%20Agua%20volcano%20background%2C%20colonial%20architecture%20rooftops%2C%20dining%20terrace%2C%20warm%20golden%20hour%20lighting%2C%20romantic%20atmosphere%2C%20travel%20dining%20photography&width=800&height=600&seq=rooftop-restaurant&orientation=landscape"
                  alt="Rooftop restaurant with volcano views"
                  className="w-full h-full object-cover object-center rounded-lg shadow-md"
                  loading="lazy"
                  decoding="async"
                />
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Best Day Trips */}
      <section id="day-trips" className="py-16 bg-gray-50">
        <div className="max-w-6xl mx-auto px-4">
          <h2 className="text-4xl font-bold text-gray-900 mb-8">Best Day Trips from Antigua</h2>
          <p className="text-lg text-gray-700 mb-12">
            Antigua's central location makes it the perfect base for exploring Guatemala's highlights. These day trips offer cultural immersion, natural beauty, and unique experiences beyond the colonial city.
          </p>

          <div className="grid md:grid-cols-2 gap-8">
            {/* Lake Atitlan */}
            <Link to="/antigua-guatemala-itineraries" className="bg-white rounded-lg overflow-hidden shadow-sm hover:shadow-md transition cursor-pointer group">
              <div className="w-full h-64">
                <img 
                  src="https://readdy.ai/api/search-image?query=Lake%20Atitlan%20Guatemala%20panoramic%20view%2C%20three%20volcanoes%2C%20colorful%20indigenous%20villages%2C%20blue%20lake%20water%2C%20traditional%20boats%2C%20stunning%20landscape%20photography%2C%20clear%20sky&width=700&height=500&seq=lake-atitlan-day-trip&orientation=landscape"
                  alt="Lake Atitlan day trip"
                  className="w-full h-full object-cover object-center"
                  loading="lazy"
                  decoding="async"
                />
              </div>
              <div className="p-6">
                <h3 className="text-2xl font-bold text-gray-900 mb-3 group-hover:text-teal-500 transition">Lake Atitlán</h3>
                <p className="text-gray-700 mb-4">
                  Often called the most beautiful lake in the world, Atitlán is surrounded by three volcanoes and traditional Mayan villages. Day trips include boat rides, village visits, and stunning photo opportunities.
                </p>
                <div className="flex flex-wrap gap-2 text-sm text-gray-600 mb-4">
                  <span className="bg-gray-100 px-3 py-1 rounded-full">Full day</span>
                  <span className="bg-gray-100 px-3 py-1 rounded-full">3 hours each way</span>
                  <span className="bg-gray-100 px-3 py-1 rounded-full">$40-60</span>
                </div>
                <span className="text-teal-500 font-semibold group-hover:text-teal-600">Learn More →</span>
              </div>
            </Link>

            {/* Chichicastenango */}
            <Link to="/antigua-guatemala-itineraries" className="bg-white rounded-lg overflow-hidden shadow-sm hover:shadow-md transition cursor-pointer group">
              <div className="w-full h-64">
                <img 
                  src="https://readdy.ai/api/search-image?query=Chichicastenango%20market%20Guatemala%20colorful%20textiles%2C%20indigenous%20vendors%2C%20vibrant%20handicrafts%2C%20traditional%20market%20scene%2C%20cultural%20experience%2C%20bright%20colors%2C%20bustling%20atmosphere&width=700&height=500&seq=chichicastenango-market&orientation=landscape"
                  alt="Chichicastenango market"
                  className="w-full h-full object-cover object-center"
                  loading="lazy"
                  decoding="async"
                />
              </div>
              <div className="p-6">
                <h3 className="text-2xl font-bold text-gray-900 mb-3 group-hover:text-teal-500 transition">Chichicastenango Market</h3>
                <p className="text-gray-700 mb-4">
                  Central America's largest indigenous market operates Thursdays and Sundays. Shop for textiles, masks, pottery, and handicrafts while experiencing authentic Mayan culture and traditions.
                </p>
                <div className="flex flex-wrap gap-2 text-sm text-gray-600 mb-4">
                  <span className="bg-gray-100 px-3 py-1 rounded-full">Thu &amp; Sun only</span>
                  <span className="bg-gray-100 px-3 py-1 rounded-full">2.5 hours each way</span>
                  <span className="bg-gray-100 px-3 py-1 rounded-full">$35-50</span>
                </div>
                <span className="text-teal-500 font-semibold group-hover:text-teal-600">Learn More →</span>
              </div>
            </Link>

            {/* Hobbitenango */}
            <Link to="/antigua-guatemala-itineraries" className="bg-white rounded-lg overflow-hidden shadow-sm hover:shadow-md transition cursor-pointer group">
              <div className="w-full h-64">
                <img 
                  src="https://readdy.ai/api/search-image?query=Hobbitenango%20Guatemala%20whimsical%20hobbit%20houses%2C%20colorful%20fantasy%20architecture%2C%20mountain%20valley%20setting%2C%20playful%20tourist%20attraction%2C%20unique%20travel%20destination%2C%20bright%20cheerful%20colors&width=700&height=500&seq=hobbitenango-attraction&orientation=landscape"
                  alt="Hobbitenango day trip"
                  className="w-full h-full object-cover object-center"
                  loading="lazy"
                  decoding="async"
                />
              </div>
              <div className="p-6">
                <h3 className="text-2xl font-bold text-gray-900 mb-3 group-hover:text-teal-500 transition">Hobbitenango</h3>
                <p className="text-gray-700 mb-4">
                  A whimsical eco-park featuring hobbit-style houses, giant hand sculptures, and panoramic valley views. Perfect for Instagram photos, zip-lining, and a fun break from colonial architecture.
                </p>
                <div className="flex flex-wrap gap-2 text-sm text-gray-600 mb-4">
                  <span className="bg-gray-100 px-3 py-1 rounded-full">Half day</span>
                  <span className="bg-gray-100 px-3 py-1 rounded-full">45 mins each way</span>
                  <span className="bg-gray-100 px-3 py-1 rounded-full">$25-35</span>
                </div>
                <span className="text-teal-500 font-semibold group-hover:text-teal-600">Learn More →</span>
              </div>
            </Link>

            {/* Iximche Ruins */}
            <Link to="/antigua-guatemala-itineraries" className="bg-white rounded-lg overflow-hidden shadow-sm hover:shadow-md transition cursor-pointer group">
              <div className="w-full h-64">
                <img 
                  src="https://readdy.ai/api/search-image?query=Iximche%20Mayan%20ruins%20Guatemala%20ancient%20pyramids%2C%20archaeological%20site%2C%20stone%20structures%2C%20historical%20landmark%2C%20green%20grass%20plaza%2C%20cultural%20heritage%2C%20archaeological%20photography&width=700&height=500&seq=iximche-ruins&orientation=landscape"
                  alt="Iximche Mayan ruins"
                  className="w-full h-full object-cover object-center"
                  loading="lazy"
                  decoding="async"
                />
              </div>
              <div className="p-6">
                <h3 className="text-2xl font-bold text-gray-900 mb-3 group-hover:text-teal-500 transition">Iximché Mayan Ruins</h3>
                <p className="text-gray-700 mb-4">
                  Pre-Columbian Mayan ruins that served as the Kaqchikel capital. Less crowded than Tikal, these ruins offer pyramid temples, ball courts, and active Mayan ceremonies in a peaceful setting.
                </p>
                <div className="flex flex-wrap gap-2 text-sm text-gray-600 mb-4">
                  <span className="bg-gray-100 px-3 py-1 rounded-full">Half day</span>
                  <span className="bg-gray-100 px-3 py-1 rounded-full">1.5 hours each way</span>
                  <span className="bg-gray-100 px-3 py-1 rounded-full">$30-45</span>
                </div>
                <span className="text-teal-500 font-semibold group-hover:text-teal-600">Learn More →</span>
              </div>
            </Link>
          </div>

          <div className="text-center mt-12">
            <Link to="/antigua-guatemala-itineraries" className="inline-block bg-teal-500 hover:bg-teal-600 text-white px-8 py-4 rounded-lg font-semibold transition whitespace-nowrap cursor-pointer">
              View Sample Itineraries
            </Link>
          </div>
        </div>
      </section>

      {/* Map Section */}
      <section id="map" className="py-16 bg-white">
        <div className="max-w-6xl mx-auto px-4">
          <h2 className="text-3xl font-bold text-gray-900 mb-4">Map of Antigua Guatemala's Top Spots</h2>
          <p className="text-lg text-gray-700 mb-8">
            All 25 attractions, viewpoints, and day-trip departure points in one place. Use the map to plan your walking routes and estimate distances between sites.
          </p>

          {/* Zone legend */}
          <div className="flex flex-wrap gap-3 mb-6">
            <span className="inline-flex items-center gap-2 bg-teal-50 text-teal-700 text-sm font-medium px-3 py-1.5 rounded-full">
              <span className="w-2.5 h-2.5 rounded-full bg-teal-500 inline-block"></span>
              Colonial Center
            </span>
            <span className="inline-flex items-center gap-2 bg-orange-50 text-orange-700 text-sm font-medium px-3 py-1.5 rounded-full">
              <span className="w-2.5 h-2.5 rounded-full bg-orange-400 inline-block"></span>
              Viewpoints &amp; Hikes
            </span>
            <span className="inline-flex items-center gap-2 bg-amber-50 text-amber-700 text-sm font-medium px-3 py-1.5 rounded-full">
              <span className="w-2.5 h-2.5 rounded-full bg-amber-400 inline-block"></span>
              Coffee &amp; Food
            </span>
            <span className="inline-flex items-center gap-2 bg-rose-50 text-rose-700 text-sm font-medium px-3 py-1.5 rounded-full">
              <span className="w-2.5 h-2.5 rounded-full bg-rose-400 inline-block"></span>
              Day Trip Departures
            </span>
          </div>

          {/* Google Maps embed */}
          <div className="w-full rounded-xl overflow-hidden shadow-md border border-gray-100" style={{ height: '480px' }}>
            <iframe
              title="Map of Antigua Guatemala attractions"
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d15448.123456789!2d-90.73400!3d14.55890!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x8589a1b3e4f3e3e3%3A0x1234567890abcdef!2sAntigua%20Guatemala!5e0!3m2!1sen!2sus!4v1700000000000!5m2!1sen!2sus"
              width="100%"
              height="100%"
              style={{ border: 0 }}
              allowFullScreen
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
            ></iframe>
          </div>

          {/* Quick anchor links by zone */}
          <div className="mt-8 grid md:grid-cols-4 gap-4">
            <div className="bg-teal-50 p-4 rounded-lg">
              <h3 className="font-bold text-teal-800 mb-2 text-sm uppercase tracking-wide">Colonial Center</h3>
              <ul className="space-y-1 text-sm text-teal-700">
                <li><a href="#santa-catalina-arch" className="hover:underline cursor-pointer">Santa Catalina Arch</a></li>
                <li><a href="#la-merced-church" className="hover:underline cursor-pointer">La Merced Church</a></li>
                <li><a href="#antigua-cathedral-ruins" className="hover:underline cursor-pointer">Cathedral Ruins</a></li>
                <li><a href="#central-park" className="hover:underline cursor-pointer">Central Park</a></li>
                <li><a href="#convento-capuchinas" className="hover:underline cursor-pointer">Convento Capuchinas</a></li>
              </ul>
            </div>
            <div className="bg-orange-50 p-4 rounded-lg">
              <h3 className="font-bold text-orange-800 mb-2 text-sm uppercase tracking-wide">Viewpoints &amp; Hikes</h3>
              <ul className="space-y-1 text-sm text-orange-700">
                <li><a href="#cerro-de-la-cruz" className="hover:underline cursor-pointer">Cerro de la Cruz</a></li>
                <li><a href="#acatenango-volcano-hike" className="hover:underline cursor-pointer">Acatenango Hike</a></li>
                <li><a href="#pacaya-volcano" className="hover:underline cursor-pointer">Pacaya Volcano</a></li>
                <li><a href="#outdoor-adventure" className="hover:underline cursor-pointer">ATV Tours</a></li>
              </ul>
            </div>
            <div className="bg-amber-50 p-4 rounded-lg">
              <h3 className="font-bold text-amber-800 mb-2 text-sm uppercase tracking-wide">Coffee &amp; Food</h3>
              <ul className="space-y-1 text-sm text-amber-700">
                <li><a href="#coffee-farm-tours" className="hover:underline cursor-pointer">Coffee Farm Tours</a></li>
                <li><a href="#chocolate-workshops" className="hover:underline cursor-pointer">Chocolate Workshops</a></li>
                <li><a href="#local-markets" className="hover:underline cursor-pointer">Local Markets</a></li>
                <li><a href="#rooftop-restaurants" className="hover:underline cursor-pointer">Rooftop Restaurants</a></li>
              </ul>
            </div>
            <div className="bg-rose-50 p-4 rounded-lg">
              <h3 className="font-bold text-rose-800 mb-2 text-sm uppercase tracking-wide">Day Trips</h3>
              <ul className="space-y-1 text-sm text-rose-700">
                <li><a href="#day-trips" className="hover:underline cursor-pointer">Lake Atitlán</a></li>
                <li><a href="#day-trips" className="hover:underline cursor-pointer">Chichicastenango</a></li>
                <li><a href="#day-trips" className="hover:underline cursor-pointer">Hobbitenango</a></li>
                <li><a href="#day-trips" className="hover:underline cursor-pointer">Iximché Ruins</a></li>
              </ul>
            </div>
          </div>
        </div>
      </section>

      {/* Free Things to Do */}
      <section id="free-things" className="py-16 bg-white">
        <div className="max-w-4xl mx-auto px-4">
          <h2 className="text-3xl font-bold text-gray-900 mb-6">Free Things to Do in Antigua Guatemala</h2>
          <p className="text-lg text-gray-700 mb-8">
            Antigua offers plenty of incredible experiences that won't cost you a quetzal. The city's colonial architecture, public spaces, and natural viewpoints provide endless opportunities for budget-conscious travelers to enjoy authentic Guatemalan culture.
          </p>
          <div className="grid md:grid-cols-2 gap-6">
            <div className="bg-gray-50 p-6 rounded-lg">
              <div className="flex items-start gap-3 mb-3">
                <i className="ri-walk-line text-teal-500 text-2xl flex-shrink-0"></i>
                <div>
                  <h3 className="font-bold text-gray-900 mb-2">Walking the Colonial Streets</h3>
                  <p className="text-gray-700 text-sm">Explore cobblestone streets, photograph colorful facades, and discover hidden courtyards. The entire colonial center is walkable and photogenic.</p>
                </div>
              </div>
            </div>
            <div className="bg-gray-50 p-6 rounded-lg">
              <div className="flex items-start gap-3 mb-3">
                <i className="ri-building-line text-teal-500 text-2xl flex-shrink-0"></i>
                <div>
                  <h3 className="font-bold text-gray-900 mb-2">Santa Catalina Arch</h3>
                  <p className="text-gray-700 text-sm">Visit Antigua's most iconic landmark anytime. Best at golden hour when the yellow arch glows against Agua volcano.</p>
                </div>
              </div>
            </div>
            <div className="bg-gray-50 p-6 rounded-lg">
              <div className="flex items-start gap-3 mb-3">
                <i className="ri-landscape-line text-teal-500 text-2xl flex-shrink-0"></i>
                <div>
                  <h3 className="font-bold text-gray-900 mb-2">Cerro de la Cruz Hike</h3>
                  <p className="text-gray-700 text-sm">Free panoramic viewpoint over the city and volcanoes. Go in a group during busy hours for safety.</p>
                </div>
              </div>
            </div>
            <div className="bg-gray-50 p-6 rounded-lg">
              <div className="flex items-start gap-3 mb-3">
                <i className="ri-community-line text-teal-500 text-2xl flex-shrink-0"></i>
                <div>
                  <h3 className="font-bold text-gray-900 mb-2">Central Park Evening Strolls</h3>
                  <p className="text-gray-700 text-sm">Relax in the heart of Antigua, watch street performers, and soak in the colonial atmosphere.</p>
                </div>
              </div>
            </div>
            <div className="bg-gray-50 p-6 rounded-lg">
              <div className="flex items-start gap-3 mb-3">
                <i className="ri-church-line text-teal-500 text-2xl flex-shrink-0"></i>
                <div>
                  <h3 className="font-bold text-gray-900 mb-2">Church Exteriors &amp; Ruins</h3>
                  <p className="text-gray-700 text-sm">Admire baroque facades of La Merced, San Francisco, and other colonial churches from outside (free).</p>
                </div>
              </div>
            </div>
            <div className="bg-gray-50 p-6 rounded-lg">
              <div className="flex items-start gap-3 mb-3">
                <i className="ri-shopping-basket-line text-teal-500 text-2xl flex-shrink-0"></i>
                <div>
                  <h3 className="font-bold text-gray-900 mb-2">Browse Local Markets</h3>
                  <p className="text-gray-700 text-sm">Wander through Mercado Central and artisan markets. No purchase required—just enjoy the colors and culture.</p>
                </div>
              </div>
            </div>
            <div className="bg-gray-50 p-6 rounded-lg">
              <div className="flex items-start gap-3 mb-3">
                <i className="ri-sun-line text-teal-500 text-2xl flex-shrink-0"></i>
                <div>
                  <h3 className="font-bold text-gray-900 mb-2">Sunset from Public Plazas</h3>
                  <p className="text-gray-700 text-sm">Watch the volcanoes turn orange from various public viewpoints around the city.</p>
                </div>
              </div>
            </div>
            <div className="bg-gray-50 p-6 rounded-lg">
              <div className="flex items-start gap-3 mb-3">
                <i className="ri-camera-line text-teal-500 text-2xl flex-shrink-0"></i>
                <div>
                  <h3 className="font-bold text-gray-900 mb-2">Photography Walks</h3>
                  <p className="text-gray-700 text-sm">Capture colonial doors, street art, volcano views, and daily life throughout the city.</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Things to Do at Night */}
      <section id="night-activities" className="py-16 bg-gray-50">
        <div className="max-w-4xl mx-auto px-4">
          <h2 className="text-3xl font-bold text-gray-900 mb-6">Things to Do in Antigua Guatemala at Night</h2>
          <p className="text-lg text-gray-700 mb-8">
            While Antigua is quieter at night than major cities, there are still enjoyable evening activities. The colonial center is generally safe in well-lit, populated areas, but always use common sense and stick to main streets.
          </p>
          <div className="space-y-6">
            <div className="bg-white p-6 rounded-lg shadow-sm">
              <h3 className="text-xl font-bold text-gray-900 mb-3">Rooftop Sunset Dining</h3>
              <p className="text-gray-700 mb-3">
                Arrive at rooftop restaurants like Café Sky or Sobremesa by 5:30 PM to watch the sunset over the volcanoes. Stay for dinner and enjoy the city lights below. This is the most popular evening activity and perfectly safe.
              </p>
              <span className="text-sm text-gray-600">Best for: Couples, photographers, foodies</span>
            </div>
            <div className="bg-white p-6 rounded-lg shadow-sm">
              <h3 className="text-xl font-bold text-gray-900 mb-3">Central Park Evening Strolls</h3>
              <p className="text-gray-700 mb-3">
                The park and surrounding streets come alive in the evening with families, street vendors, and tourists. It's well-lit and safe, perfect for an after-dinner walk or ice cream from local shops.
              </p>
              <span className="text-sm text-gray-600">Best for: Families, casual walks</span>
            </div>
            <div className="bg-white p-6 rounded-lg shadow-sm">
              <h3 className="text-xl font-bold text-gray-900 mb-3">Live Music &amp; Bars</h3>
              <p className="text-gray-700 mb-3">
                Several bars and restaurants feature live music, especially on weekends. Popular spots include Café No Sé (jazz), Reilly's (Irish pub), and various venues along 5th Avenue. Stick to established venues and travel in groups.
              </p>
              <span className="text-sm text-gray-600">Best for: Music lovers, social travelers</span>
            </div>
            <div className="bg-white p-6 rounded-lg shadow-sm">
              <h3 className="text-xl font-bold text-gray-900 mb-3">Evening Church Visits</h3>
              <p className="text-gray-700 mb-3">
                Some churches hold evening masses and are beautifully lit at night. La Merced and San Francisco are particularly atmospheric in the evening (check schedules for access).
              </p>
              <span className="text-sm text-gray-600">Best for: Cultural experiences, photography</span>
            </div>
            <div className="bg-teal-50 p-6 rounded-lg border-l-4 border-teal-500">
              <p className="text-gray-700">
                <strong className="text-gray-900">Pro tip:</strong> Rain usually comes in the afternoon (2-6 PM). Plan outdoor activities for mornings, then shift to indoor experiences after lunch. Bring a light rain jacket and you'll be fine.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Rainy Day Activities */}
      <section id="rainy-day" className="py-16 bg-white">
        <div className="max-w-4xl mx-auto px-4">
          <h2 className="text-3xl font-bold text-gray-900 mb-6">Rainy Day Activities in Antigua</h2>
          <p className="text-lg text-gray-700 mb-8">
            Antigua's rainy season (May–October) brings afternoon showers, but that doesn't mean you're stuck. These indoor and covered activities are perfect when the skies open up.
          </p>
          <div className="grid md:grid-cols-2 gap-6">
            <div className="bg-gray-50 p-6 rounded-lg">
              <div className="flex items-start gap-3">
                <div className="w-10 h-10 flex items-center justify-center bg-teal-100 text-teal-600 rounded-lg flex-shrink-0">
                  <i className="ri-book-open-line text-xl"></i>
                </div>
                <div>
                  <h3 className="font-bold text-gray-900 mb-2">Spanish Language Classes</h3>
                  <p className="text-gray-700 text-sm">Antigua is one of the world's top destinations for Spanish immersion. Schools like PLQ and CSA offer daily group or private lessons. A rainy afternoon is the perfect excuse to start.</p>
                  <span className="text-xs text-gray-500 mt-1 block">Cost: $8–15/hour · All levels</span>
                </div>
              </div>
            </div>
            <div className="bg-gray-50 p-6 rounded-lg">
              <div className="flex items-start gap-3">
                <div className="w-10 h-10 flex items-center justify-center bg-teal-100 text-teal-600 rounded-lg flex-shrink-0">
                  <i className="ri-store-2-line text-xl"></i>
                </div>
                <div>
                  <h3 className="font-bold text-gray-900 mb-2">Artisan Textile Shopping</h3>
                  <p className="text-gray-700 text-sm">Browse covered artisan markets and boutique shops for handwoven huipiles, jade jewelry, and hand-painted ceramics. Casa de los Gigantes and Nim Po't are excellent covered options.</p>
                  <span className="text-xs text-gray-500 mt-1 block">Cost: Free to browse · Central location</span>
                </div>
              </div>
            </div>
            <div className="bg-gray-50 p-6 rounded-lg">
              <div className="flex items-start gap-3">
                <div className="w-10 h-10 flex items-center justify-center bg-teal-100 text-teal-600 rounded-lg flex-shrink-0">
                  <i className="ri-museum-line text-xl"></i>
                </div>
                <div>
                  <h3 className="font-bold text-gray-900 mb-2">Colonial Museums</h3>
                  <p className="text-gray-700 text-sm">Museo de Arte Colonial, Casa Popenoe, and the Jade Museum are all indoor experiences that bring Antigua's history to life. Budget 1–2 hours each.</p>
                  <span className="text-xs text-gray-500 mt-1 block">Cost: $3–8 · 1–2 hours each</span>
                </div>
              </div>
            </div>
            <div className="bg-gray-50 p-6 rounded-lg">
              <div className="flex items-start gap-3">
                <div className="w-10 h-10 flex items-center justify-center bg-teal-100 text-teal-600 rounded-lg flex-shrink-0">
                  <i className="ri-cup-line text-xl"></i>
                </div>
                <div>
                  <h3 className="font-bold text-gray-900 mb-2">Café Hopping &amp; Coffee Tastings</h3>
                  <p className="text-gray-700 text-sm">Antigua has world-class specialty coffee cafés. Spend a rainy afternoon at Fernando's Kaffee, Café Condesa, or Epicure tasting single-origin Guatemalan beans.</p>
                  <span className="text-xs text-gray-500 mt-1 block">Cost: $3–8 per drink · Colonial center</span>
                </div>
              </div>
            </div>
            <div className="bg-gray-50 p-6 rounded-lg">
              <div className="flex items-start gap-3">
                <div className="w-10 h-10 flex items-center justify-center bg-teal-100 text-teal-600 rounded-lg flex-shrink-0">
                  <i className="ri-restaurant-line text-xl"></i>
                </div>
                <div>
                  <h3 className="font-bold text-gray-900 mb-2">Cooking Classes</h3>
                  <p className="text-gray-700 text-sm">Learn to make traditional Guatemalan dishes like pepián, tamales, and chiles rellenos. Several restaurants and schools offer hands-on cooking experiences.</p>
                  <span className="text-xs text-gray-500 mt-1 block">Cost: $30–50 · 3–4 hours</span>
                </div>
              </div>
            </div>
            <div className="bg-gray-50 p-6 rounded-lg">
              <div className="flex items-start gap-3">
                <div className="w-10 h-10 flex items-center justify-center bg-teal-100 text-teal-600 rounded-lg flex-shrink-0">
                  <i className="ri-film-line text-xl"></i>
                </div>
                <div>
                  <h3 className="font-bold text-gray-900 mb-2">Chocolate &amp; Craft Workshops</h3>
                  <p className="text-gray-700 text-sm">ChocoMuseo and other artisan workshops run daily sessions regardless of weather. Make your own chocolate bar or learn traditional weaving techniques.</p>
                  <span className="text-xs text-gray-500 mt-1 block">Cost: $20–30 · 2 hours</span>
                </div>
              </div>
            </div>
          </div>
          <div className="mt-6 bg-teal-50 p-5 rounded-lg border-l-4 border-teal-500">
            <p className="text-gray-700 text-sm">
              <strong className="text-gray-900">Pro tip:</strong> Rain in Antigua is usually predictable — clear mornings, showers from 2–6 PM. Schedule outdoor activities before noon and save indoor experiences for the afternoon.
            </p>
          </div>
        </div>
      </section>

      {/* How Many Days Section */}
      <section className="py-16 bg-gray-50">
        <div className="max-w-4xl mx-auto px-4">
          <h2 className="text-3xl font-bold text-gray-900 mb-8">How Many Days Do You Need in Antigua?</h2>
          
          <div className="space-y-6">
            <div className="bg-white p-6 rounded-lg shadow-sm">
              <h3 className="text-xl font-bold text-gray-900 mb-3">2 Days in Antigua</h3>
              <p className="text-gray-700 mb-3">
                Perfect for a quick weekend trip. Focus on the colonial center, one volcano hike (Pacaya), and essential landmarks. You'll get a taste of Antigua but will leave wanting more.
              </p>
              <Link to="/antigua-guatemala-itineraries" className="text-teal-500 hover:text-teal-600 font-semibold cursor-pointer">
                See 2-Day Itinerary →
              </Link>
            </div>

            <div className="bg-white p-6 rounded-lg shadow-sm">
              <h3 className="text-xl font-bold text-gray-900 mb-3">3 Days in Antigua (Recommended)</h3>
              <p className="text-gray-700 mb-3">
                The sweet spot for most US travelers. Enough time for city exploration, the Acatenango overnight hike, and one day trip or relaxation day. You'll experience the highlights without feeling rushed.
              </p>
              <Link to="/antigua-guatemala-itineraries" className="text-teal-500 hover:text-teal-600 font-semibold cursor-pointer">
                See 3-Day Itinerary →
              </Link>
            </div>

            <div className="bg-white p-6 rounded-lg shadow-sm">
              <h3 className="text-xl font-bold text-gray-900 mb-3">5 Days in Antigua</h3>
              <p className="text-gray-700 mb-3">
                Ideal for a comprehensive experience. Add multiple day trips (Lake Atitlán, Chichicastenango), coffee tours, Spanish classes, and time to truly relax in boutique hotels. You'll leave feeling like you really know Antigua.
              </p>
              <Link to="/antigua-guatemala-itineraries" className="text-teal-500 hover:text-teal-600 font-semibold cursor-pointer">
                See 5-Day Itinerary →
              </Link>
            </div>
          </div>
        </div>
      </section>

      {/* Things to Do by Area */}
      <section className="py-16 bg-white">
        <div className="max-w-6xl mx-auto px-4">
          <h2 className="text-3xl font-bold text-gray-900 mb-12">Things to Do by Area</h2>
          
          <div className="grid md:grid-cols-2 gap-8">
            <div className="bg-gray-50 p-8 rounded-lg">
              <h3 className="text-2xl font-bold text-gray-900 mb-4">Central Antigua</h3>
              <ul className="space-y-3 text-gray-700">
                <li className="flex items-start gap-3">
                  <i className="ri-checkbox-circle-fill text-teal-500 text-xl flex-shrink-0 mt-0.5"></i>
                  <span>Santa Catalina Arch &amp; surrounding streets</span>
                </li>
                <li className="flex items-start gap-3">
                  <i className="ri-checkbox-circle-fill text-teal-500 text-xl flex-shrink-0 mt-0.5"></i>
                  <span>Central Park &amp; Cathedral ruins</span>
                </li>
                <li className="flex items-start gap-3">
                  <i className="ri-checkbox-circle-fill text-teal-500 text-xl flex-shrink-0 mt-0.5"></i>
                  <span>La Merced Church</span>
                </li>
                <li className="flex items-start gap-3">
                  <i className="ri-checkbox-circle-fill text-teal-500 text-xl flex-shrink-0 mt-0.5"></i>
                  <span>Convento de las Capuchinas</span>
                </li>
                <li className="flex items-start gap-3">
                  <i className="ri-checkbox-circle-fill text-teal-500 text-xl flex-shrink-0 mt-0.5"></i>
                  <span>Mercado Central (local market)</span>
                </li>
                <li className="flex items-start gap-3">
                  <i className="ri-checkbox-circle-fill text-teal-500 text-xl flex-shrink-0 mt-0.5"></i>
                  <span>Rooftop restaurants &amp; cafes</span>
                </li>
              </ul>
            </div>

            <div className="bg-gray-50 p-8 rounded-lg">
              <h3 className="text-2xl font-bold text-gray-900 mb-4">Around the Valley</h3>
              <ul className="space-y-3 text-gray-700">
                <li className="flex items-start gap-3">
                  <i className="ri-checkbox-circle-fill text-teal-500 text-xl flex-shrink-0 mt-0.5"></i>
                  <span>Cerro de la Cruz viewpoint</span>
                </li>
                <li className="flex items-start gap-3">
                  <i className="ri-checkbox-circle-fill text-teal-500 text-xl flex-shrink-0 mt-0.5"></i>
                  <span>Coffee plantation tours</span>
                </li>
                <li className="flex items-start gap-3">
                  <i className="ri-checkbox-circle-fill text-teal-500 text-xl flex-shrink-0 mt-0.5"></i>
                  <span>Hobbitenango eco-park</span>
                </li>
                <li className="flex items-start gap-3">
                  <i className="ri-checkbox-circle-fill text-teal-500 text-xl flex-shrink-0 mt-0.5"></i>
                  <span>ATV tours through villages</span>
                </li>
                <li className="flex items-start gap-3">
                  <i className="ri-checkbox-circle-fill text-teal-500 text-xl flex-shrink-0 mt-0.5"></i>
                  <span>Traditional Mayan villages</span>
                </li>
              </ul>
            </div>

            <div className="bg-gray-50 p-8 rounded-lg">
              <h3 className="text-2xl font-bold text-gray-900 mb-4">Nearby Volcanoes</h3>
              <ul className="space-y-3 text-gray-700">
                <li className="flex items-start gap-3">
                  <i className="ri-checkbox-circle-fill text-teal-500 text-xl flex-shrink-0 mt-0.5"></i>
                  <span>Acatenango overnight hike</span>
                </li>
                <li className="flex items-start gap-3">
                  <i className="ri-checkbox-circle-fill text-teal-500 text-xl flex-shrink-0 mt-0.5"></i>
                  <span>Pacaya volcano day trip</span>
                </li>
                <li className="flex items-start gap-3">
                  <i className="ri-checkbox-circle-fill text-teal-500 text-xl flex-shrink-0 mt-0.5"></i>
                  <span>Fuego viewpoints (from safe distance)</span>
                </li>
                <li className="flex items-start gap-3">
                  <i className="ri-checkbox-circle-fill text-teal-500 text-xl flex-shrink-0 mt-0.5"></i>
                  <span>Agua volcano summit hike</span>
                </li>
              </ul>
            </div>

            <div className="bg-gray-50 p-8 rounded-lg">
              <h3 className="text-2xl font-bold text-gray-900 mb-4">Day Trips</h3>
              <ul className="space-y-3 text-gray-700">
                <li className="flex items-start gap-3">
                  <i className="ri-checkbox-circle-fill text-teal-500 text-xl flex-shrink-0 mt-0.5"></i>
                  <span>Lake Atitlán &amp; villages</span>
                </li>
                <li className="flex items-start gap-3">
                  <i className="ri-checkbox-circle-fill text-teal-500 text-xl flex-shrink-0 mt-0.5"></i>
                  <span>Chichicastenango market</span>
                </li>
                <li className="flex items-start gap-3">
                  <i className="ri-checkbox-circle-fill text-teal-500 text-xl flex-shrink-0 mt-0.5"></i>
                  <span>Iximché Mayan ruins</span>
                </li>
                <li className="flex items-start gap-3">
                  <i className="ri-checkbox-circle-fill text-teal-500 text-xl flex-shrink-0 mt-0.5"></i>
                  <span>Monterrico black sand beaches</span>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </section>

      {/* Safety & Best Time */}
      <section id="safety-timing" className="py-16 bg-gray-50">
        <div className="max-w-4xl mx-auto px-4">
          <div className="grid md:grid-cols-2 gap-12">
            <div>
              <h2 className="text-3xl font-bold text-gray-900 mb-6">Is Antigua Guatemala Safe?</h2>
              <p className="text-gray-700 mb-4">
                Yes, Antigua is generally safe for US travelers and is considered one of the safest cities in Guatemala. The colonial center has a visible police and tourist police presence, and violent crime against tourists is rare.
              </p>
              <p className="text-gray-700 mb-4">
                <strong className="text-gray-900">Common sense precautions:</strong> Don't walk alone late at night in quiet areas, avoid displaying expensive jewelry or electronics, use official taxis or Uber, and go to Cerro de la Cruz in groups during busy hours.
              </p>
              <p className="text-gray-700 mb-6">
                Most US travelers visit Antigua without any safety issues. The city's tourism infrastructure is well-developed, and locals are accustomed to international visitors.
              </p>
              <Link to="/editorial-policy" className="text-teal-500 hover:text-teal-600 cursor-pointer">Editorial Policy</Link>
            </div>

            <div>
              <h2 className="text-3xl font-bold text-gray-900 mb-6">Best Time to Visit for Activities</h2>
              <p className="text-gray-700 mb-4">
                <strong className="text-gray-900">Dry Season (November-April):</strong> Best for volcano hikes, outdoor activities, and clear volcano views. Peak season is December-March with perfect weather but higher prices and more crowds.
              </p>
              <p className="text-gray-700 mb-4">
                <strong className="text-gray-900">Rainy Season (May-October):</strong> Afternoon showers, lush green landscapes, fewer tourists, and lower prices. Morning activities usually stay dry. Not ideal for Acatenango camping.
              </p>
              <p className="text-gray-700 mb-6">
                <strong className="text-gray-900">Special Events:</strong> Semana Santa (Holy Week) in March or April features spectacular processions but extreme crowds. Book months in advance if visiting during this time.
              </p>
              <Link to="/antigua-guatemala-travel-guide" className="text-teal-500 hover:text-teal-600 font-semibold cursor-pointer">
                Read Complete Safety Guide →
              </Link>
            </div>
          </div>
        </div>
      </section>

      {/* FAQ Section */}
      <section className="py-16 bg-white">
        <div className="max-w-4xl mx-auto px-4">
          <h2 className="text-3xl font-bold text-gray-900 mb-12 text-center">Frequently Asked Questions</h2>
          <div className="space-y-6">
            {faqs.map((faq, index) => (
              <div key={index} className="bg-gray-50 p-6 rounded-lg">
                <h3 className="text-xl font-bold text-gray-900 mb-3">{faq.question}</h3>
                <p className="text-gray-700 leading-relaxed">{faq.answer}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Final CTA */}
      <section className="py-16 bg-teal-500">
        <div className="max-w-4xl mx-auto px-4 text-center">
          <h2 className="text-4xl font-bold text-white mb-6">Ready to Experience Antigua Guatemala?</h2>
          <p className="text-xl text-white/90 mb-8">Get personalized recommendations for your perfect Antigua itinerary, including activities, hotels, and transportation.</p>
          <div className="flex flex-wrap gap-4 justify-center">
            <Link to="/plan-my-antigua-trip" className="inline-block bg-white hover:bg-gray-100 text-teal-500 px-8 py-4 rounded-lg font-semibold text-lg transition whitespace-nowrap cursor-pointer">
              Plan My Trip
            </Link>
            <Link to="/antigua-guatemala-itineraries" className="inline-block bg-teal-600 hover:bg-teal-700 text-white px-8 py-4 rounded-lg font-semibold text-lg transition whitespace-nowrap cursor-pointer">
              View Sample Itineraries
            </Link>
          </div>
        </div>
      </section>

      {/* Last Updated */}
      <section className="py-8 bg-white border-t border-gray-200">
        <div className="max-w-4xl mx-auto px-4 text-center text-sm text-gray-600">
          <p>Written by the La Antigua Guatemala travel team</p>
          <p className="mt-1 text-gray-500">
            <time dateTime="2025-06-01">Published June 1, 2025</time>
            {' · '}
            <time dateTime="2026-02-20"><strong className="text-gray-700">Last updated February 20, 2026</strong></time>
          </p>
          <div className="mt-2">
            <Link to="/editorial-policy" className="text-teal-500 hover:text-teal-600 cursor-pointer">Editorial Policy</Link>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
}